import IconHeader from '../../../../components/Table/TableCells/IconHeader/IconHeader'

export const columns = [
  {
    Header: 'Fecha de creación',
    accessor: 'dFechaCreacion',
    type: 'date',
  },
  {
    Header: IconHeader,
    label: 'Rut',
    accessor: 'sRUT',
    type: 'dni',
    sortBy: 'RUT',
  },
  {
    Header: IconHeader,
    label: 'Nombre',
    accessor: 'sNombre',
    sortBy: 'NOMBRE',
  },
  {
    Header: 'Estado',
    accessor: 'sEstado',
    type: 'status',
  },
  {
    Header: 'Centro de costo',
    accessor: 'CentroCosto',
  },
  {
    Header: 'Sucursal',
    accessor: 'Sucursal',
  },
  {
    Header: 'Grupo',
    accessor: 'sGrupo',
  },
]

export const nnColumns = [
  {
    Header: IconHeader,
    label: 'Fecha de creación',
    accessor: 'dFechaCreacion',
    type: 'date',
    sortBy: 'DATE',
  },
  {
    Header: IconHeader,
    label: 'NN',
    accessor: 'sEmpleado',
    sortBy: 'RUT',
  },
  {
    Header: IconHeader,
    label: 'Nombre',
    accessor: 'sNombre',
    sortBy: 'NOMBRE',
  },
  {
    Header: 'Estado',
    accessor: 'sEstado',
    type: 'status',
  },
  {
    Header: 'Centro de costo',
    accessor: 'CentroCosto',
  },
  {
    Header: 'Sucursal',
    accessor: 'Sucursal',
  },
  {
    Header: 'Grupo',
    accessor: 'sGrupo',
  },
]
export const data = [
  {
    branch_office: 'dato 1',
    cost_center: 'dato 1',
    dni: 'dato 1',
    name: 'dato 1',
    status: 'dato 1',
  },
  {
    branch_office: 'dato 2',
    cost_center: 'dato 2',
    dni: 'dato 2',
    name: 'dato 2',
    status: 'dato 2',
  },
  {
    branch_office: 'dato 3',
    cost_center: 'dato 3',
    dni: 'dato 3',
    name: 'dato 3',
    status: 'dato 3',
  },
  {
    branch_office: 'dato 4',
    cost_center: 'dato 4',
    dni: 'dato 4',
    name: 'dato 4',
    status: 'dato 4',
  },
  {
    branch_office: 'dato 5',
    cost_center: 'dato 5',
    dni: 'dato 5',
    name: 'dato 5',
    status: 'dato 5',
  },
]
